<template>
  <div class="flex gap-4 items-center w-full">
    <div class="skeleton-loading-bg h-14 aspect-[3/4] rounded shrink-0"></div>
    <div class="flex flex-col gap-4">
      <div class="skeleton-loading-bg h-4 w-20"></div>
      <div class="skeleton-loading-bg h-4 w-40"></div>
    </div>
  </div>
</template>
